import isNil from 'lodash.isnil'
import { ALL_COMMAS } from './regexConstants'

export const amtAsNumber = (amt: string | number | null | undefined) => {
  let stringAmt = amt as string
  let amtNum = amt as number
  if ((amt as string)?.replace !== undefined) {
    amtNum = Number.parseFloat(stringAmt.replace(ALL_COMMAS, ''))
  }
  return amtNum
}

export const amtValid = (amt: string | number | null) => {
  let valid = true
  if (isPrimitiveEmpty(amt)) {
    return false
  }
  const amtNum = amtAsNumber(amt)
  if (Number.isNaN(amtNum) || amtNum <= 0) {
    valid = false
  }
  return valid
}

export const isPrimitiveEmpty = (value: string | number | undefined | null) => {
  let empty = false
  if (isNil(value)) {
    empty = true
  } else if ((value as string).length !== undefined && (value as string).trim().length === 0) {
    empty = true
  }
  return empty
}
